(function() {
  const gorgiasSelector = '#gorgias-chat-container';
  const cartDrawerSelector = '#CartDrawer';
  const mobileBreakpoint = 768;

  const injectStyles = () => {
    if (document.getElementById('gorgias-fade-styles')) return;
    const style = document.createElement('style');
    style.id = 'gorgias-fade-styles';
    style.innerHTML = `
      ${gorgiasSelector} {
        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.3s !important;
      }
    `;
    document.head.appendChild(style);
  };

  const isMobile = () => window.innerWidth < mobileBreakpoint;

  const updateGorgiasVisibility = () => {
    const gorgias = document.querySelector(gorgiasSelector);
    const drawer = document.querySelector(cartDrawerSelector);
    
    if (!gorgias) return;

    if (!isMobile()) {
      gorgias.style.setProperty('opacity', '1', 'important');
      gorgias.style.setProperty('visibility', 'visible', 'important');
      gorgias.style.setProperty('pointer-events', 'auto', 'important');
      return;
    }

    if (!drawer) return;

    const isOpen = drawer.classList.contains('is-open') || 
                   drawer.classList.contains('active') || 
                   drawer.hasAttribute('open') || 
                   (window.getComputedStyle(drawer).opacity > 0 && 
                    window.getComputedStyle(drawer).visibility !== 'hidden' && 
                    window.getComputedStyle(drawer).display !== 'none');

    if (isOpen) {
      gorgias.style.setProperty('opacity', '0', 'important');
      gorgias.style.setProperty('visibility', 'hidden', 'important');
      gorgias.style.setProperty('pointer-events', 'none', 'important');
    } else {
      gorgias.style.setProperty('opacity', '1', 'important');
      gorgias.style.setProperty('visibility', 'visible', 'important');
      gorgias.style.setProperty('pointer-events', 'auto', 'important');
    }
  };

  injectStyles();

  document.addEventListener('click', () => {
    if (isMobile()) setTimeout(updateGorgiasVisibility, 100); 
  });

  const target = document.querySelector(cartDrawerSelector);
  if (target) {
    const observer = new MutationObserver(() => {
      if (isMobile()) updateGorgiasVisibility();
    });
    observer.observe(target, { attributes: true, childList: true, subtree: true });
  }

  window.addEventListener('resize', updateGorgiasVisibility);
  updateGorgiasVisibility();

  setInterval(() => {
    if (isMobile()) updateGorgiasVisibility();
  }, 120);
})();